import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { School } from '~/types/school'
import { SchoolFormDialog } from './components/school-form-dialog'
import { SchoolImportDialog } from './components/school-import-dialog'
import { SchoolsList } from './components/schools-list'

export function SchoolsPage() {
  const { t } = useTranslation()
  const [editingItem, setEditingItem] = useState<School | null>(null)

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold" id="schools-title">
        {t('schools.title')}
      </h1>
      <SchoolsList onEdit={setEditingItem} />
      <SchoolFormDialog editingItem={editingItem} />
      <SchoolImportDialog />
    </div>
  )
}
